import { agentsConstants } from '@constants/agents';

const initialState = {
    data: [],
    loading: true,
    error: '',
};

export function agents(state = initialState, action) {
    switch (action.type) {
        case agentsConstants.AGENTS_FETCH:
            return { ...state, loading: true, error: '' };
        case agentsConstants.AGENTS_SUCCESS:
            return { ...state, loading: false, data: action.data };
        case agentsConstants.AGENTS_ERROR:
            return { ...state, loading: false };
        case agentsConstants.AGENTS_UPDATE:
            return { ...state, data: action.data };
        default:
            return state;
    }
}
